import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import changeset from 'ember-changeset/helpers/changeset';
import t from 'ember-intl/helpers/t';
import add from 'ember-math-helpers/helpers/add';
import ModelList from 'parog-web/components/model-list';
import Dropdown from 'ui-kit/components/changeset/dropdown';
import DatePicker from '../../changeset/date-picker';

interface Signature {
  Args: {
    changeset: EmberChangeset;
  };
}

export default class TreatmentHistoryEditionFormBreastCancerOtherFollowUpEventsComponent extends Component<Signature> {
  get otherTypes() {
    return [
      'announcement-consultation',
      'sentinel-node-lymphoscinthigraphy',
      'ultrasound-spotting',
      'anaesthetist-consultation',
      'abdominal-ultrasound',
      'echocardiography',
      'mri',
      'mammography',
      'preoperative-nurse-appointment',
      'scanner',
      'tracking-scanner',
      'bone-scan',
      'computed-tomography',
      'smoking-cessation',
      'respiratory-cine',
      'dentist',
      'psychologist',
      'social-worker'
    ];
  }

  get #events() {
    return this.args.changeset.get('otherFollowUpEvents');
  }

  onChangesetUpdate = (changeset: EmberChangeset) => {
    changeset.execute();
    this.#setAsDirty();
  };

  #setAsDirty() {
    this.args.changeset.set('otherFollowUpEvents', [].concat(this.#events));
  }

  <template>
    <h2 class='ui dividing header'>Autre suivi du parcours</h2>
    <div class='field'>
      <div
        class='field'
        id='otherFollowUpEvents'
        data-test-other-follow-up-list
      >
        <ModelList
          @model={{@changeset}}
          @propertyName='otherFollowUpEvents'
          @addButtonTitle='Ajouter un événement'
          as |Item|
        >
          {{#let (changeset Item.item) as |eventChangeset|}}
            <div class='ui segment'>
              <h3 class='ui dividing header'>Événement
                {{add Item.index 1}}</h3>
              <i
                class='trash icon absolute right-0 top-0 m-2 opacity-[0.5]'
                role='button'
                {{on 'click' Item.destroy}}
              >
              </i>
              <div class='field'>
                <Dropdown
                  @changeset={{eventChangeset}}
                  @labelName="Type d'événement"
                  @propertyName='type'
                  @onChangesetUpdate={{this.onChangesetUpdate}}
                  as |dropdown|
                >
                  {{#each this.otherTypes as |otherType|}}
                    <dropdown.Item
                      @key={{otherType}}
                      @value={{t (concat 'other-events.' otherType)}}
                    />
                  {{/each}}
                </Dropdown>
              </div>
              <div class='field'>
                <DatePicker
                  data-test-other-follow-up-event-date={{add Item.index 1}}
                  @labelName="Date de l'événement"
                  @propertyName='date'
                  @changeset={{eventChangeset}}
                  @onChangesetUpdate={{this.onChangesetUpdate}}
                />
              </div>
            </div>
          {{/let}}
        </ModelList>
      </div>
    </div>
  </template>
}
